import React, { useCallback } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { useDrop } from 'react-dnd'
import { TagDragItem } from './tag-drag-item'
import styles from './tag-drag-area.module.css'

const TAG_AREA_ID_LEFT = 'LEFT'
const TAG_AREA_ID_RIGHT = 'RIGHT'

const propTypes = {
    areaId: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            title: PropTypes.string.isRequired
        })
    ).isRequired,
    onClick: PropTypes.func.isRequired,
    onDelete: PropTypes.func,
    onDrop: PropTypes.func.isRequired,
    tagClassName: PropTypes.string,
    title: PropTypes.string,
    titleClassName: PropTypes.string
}

const TagDragArea = ({ areaId, className, items, onClick, onDelete, onDrop, tagClassName, title }) => {
    const [{ isOver }, drop] = useDrop({
        accept: 'TAG',
        collect: monitor => ({
            isOver: monitor.isOver()
        }),
        drop: ({ draggedItem, sourceAreaId }) => {
            if (sourceAreaId !== areaId) {
                onDrop(draggedItem)
            }
        }
    })

    const areaClassName = cx(styles['tag-area'], 't3sel-tag-drag-area', {
        [styles['is-over']]: isOver
    })

    const getTagDragItems = useCallback(
        () =>
            items.map(function (item, index) {
                return (
                    <TagDragItem
                        key={item.id}
                        sourceAreaId={areaId}
                        {...{ index, item, onClick, onDelete, tagClassName }}
                    />
                )
            }),
        [items, areaId, onClick, onDelete, tagClassName]
    )

    return (
        <div className={cx(styles['wrapper'], className)}>
            {title && <span className={cx(styles['title'])}>{title}</span>}
            <div ref={drop} className={areaClassName}>
                {getTagDragItems()}
            </div>
        </div>
    )
}

TagDragArea.propTypes = propTypes

export { TagDragArea, TAG_AREA_ID_LEFT, TAG_AREA_ID_RIGHT }
